import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import IconButton from '@mui/material/IconButton';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import AdoptaHawksbill1 from '../Images/AdoptaHawksbill-1.webp';
import AdoptaHawksbill2 from '../Images/AdoptaHawksbill-2.webp';
import AdoptaHawksbill3 from '../Images/AdoptaHawksbill-3.webp';
import AdoptaHawksbill4 from '../Images/AdoptaHawksbill-4.webp';
import AdoptaHawksbill5 from '../Images/AdoptaHawksbill-5.webp';

const slides = [
  { id: 1, image: AdoptaHawksbill1, alt: "Adopt a Hawksbill Turtle" },
  { id: 2, image: AdoptaHawksbill2, alt: "Another Turtle View" },
  { id: 3, image: AdoptaHawksbill3, alt: "Third Turtle Shot" },
  { id: 3, image: AdoptaHawksbill4, alt: "Third Turtle Shot" },
  { id: 3, image: AdoptaHawksbill5, alt: "Third Turtle Shot" },
];

const variants = {
  enter: (direction) => ({
    x: direction > 0 ? 300 : -300,
    opacity: 0,
  }),
  center: {
    x: 0,
    opacity: 1,
  },
  exit: (direction) => ({
    x: direction < 0 ? 300 : -300,
    opacity: 0,
  }),
};

const HawksbillShow = () => {

  const [[page, direction], setPage] = useState([0, 0]);

  const paginate = (newDirection) => {
    setPage([
      (page + newDirection + slides.length) % slides.length,
      newDirection,
    ]);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      paginate(1);
    }, 5000); // 5000ms = 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, [page]);

  const theme = useTheme();

  return (
    <div className="w-full mx-auto">
      <div className="relative h-[640px] overflow-hidden clear-both rounded-2xl shadow-lg">
        <AnimatePresence initial={false} custom={direction}>
          <motion.div
            key={page}
            custom={direction}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ duration: 0.5 }}
            className="absolute w-full h-full"
          >
            <img
              src={slides[page].image}
              alt={slides[page].alt}
              className="w-full h-full object-cover"
            />
          </motion.div>
        </AnimatePresence>

        {/* MUI Icon Buttons inside image */}
        <div className="absolute top-1/2 left-4 -translate-y-1/2 z-10">
          <IconButton
            onClick={() => paginate(-1)}
            sx={{
              color: '#ffffff',
              backgroundColor: 'rgba(242,121,32)',

              '&:hover': {
                backgroundColor: 'rgba(0,146,147)',
              },
            }}
          >
            <ArrowBackIos />
          </IconButton>
        </div>

        <div className="absolute top-1/2 right-4 -translate-y-1/2 z-10">
          <IconButton
            onClick={() => paginate(1)}
            sx={{
              color: '#ffffff',
              backgroundColor: 'rgba(242,121,32)',
              '&:hover': {
                backgroundColor: 'rgba(0,146,147)',
              },
            }}
          >
            <ArrowForwardIos />
          </IconButton>
        </div>
      </div>
    </div>
  )
}

export default HawksbillShow